import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-batch-delivery-add',
  templateUrl: './batch-delivery-add.component.html',
  styleUrls: ['./batch-delivery-add.component.css']
})
export class BatchDeliveryAddComponent implements OnInit {
    batchDeliveryKeyno;

    public selectedBgBatchDeliveryAddSelection: string = 'all';

    public itemsListSuppliers: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.batchDeliveryKeyno = this.stateService.getStateParams()['batchdelivery_keyno'];
    }

    private async loadSuppliers() {
        if (!!this.batchDeliveryKeyno && !!this.selectedBgBatchDeliveryAddSelection) {
            this.itemsListSuppliers = await this.datatask.Post(283, {
                batchdelivery_keyno: this.batchDeliveryKeyno,
                period_selector: this.selectedBgBatchDeliveryAddSelection
            });
        }
    }

    public onTabChanged() {
        this.loadSuppliers();
    }

    private async init() {
        this.loadSuppliers();
    }

    ngOnInit() {
        this.init();
    }
}
